import { useMemo } from "react";

import { useMarkFolderReportDownloadedMutation } from "@/graphql/folders/folders.hooks";
import { GraphqlMappedError } from "@/services/graphqlErrorService";

interface IUseMarkFolderReportDownloadedProps {
  onCompleted?: () => void;
  onError?: (error: GraphqlMappedError) => void;
}

const useMarkFolderReportDownloaded = ({
  onCompleted,
  onError,
}: IUseMarkFolderReportDownloadedProps = {}) => {
  const [mutate, { loading, error }] = useMarkFolderReportDownloadedMutation({
    context: { errorType: "local" },
    onCompleted: () => onCompleted?.(),
    onError: (e) => onError?.(GraphqlMappedError.from(e)),
  });

  return useMemo(
    () => ({
      markFolderReportDownloaded: async (folderId: number) => {
        const { data } = await mutate({ variables: { folderId } });
        return data?.markFolderReportDownloaded ?? false;
      },
      loading,
      error,
    }),
    [mutate, loading, error]
  );
};

export default useMarkFolderReportDownloaded;
